//TODO: Complete all themes
export const baseThemeData = {
  colors: {
    primary: "#FCE403",
    header: "000",
    brandColor: "#fc6200",
    textColor: "#fff",
    colorPrimary: "#717171",
    colorSecondary: "#6C6C6C",
    colorFontBlack: "#0A0A0A",
    hooverLinkColors: "#CCCCCC",
    linkBorder: "#121212",
    textColorBtnOutlined: "#fff",
    textColorBtnOutlinedHover: "#0A0A0A",
    textColorBtnOutlinedMobile: "#fff",
    textColorBtnContained: "#0A0A0A",
    textColorBtnContainedMobile: "#0A0A0A",
    ColorBtnContainedHoover: "#FCE403",
    iconColor: "#717171"
  },

  backgrounds: {
    mainBG: "#171717",
    boxBG: "#232323",
    hoverColorContained: "transparent",
    hoverColorOutlined: "transparent"
  },

  borders: {
    borderColor: "#FFFFFF",
    borderColorMobile: "#FFFFFF",
    borderBottom: "#2c2c2c",
    borderBottomFooter: "#303030",
    borderOutlineButton: "#FFF",
    borderButton: "#FCE403",
    boxShadow: "0 0 18px rgb(0 0 0 / 30%);",
    borderBoxShadow: "0px 1px 0px 0px rgba(44,44,44,1);",
    borderBoxShadowTop: "0px -1px 0px 0px rgba(44,44,44,1);"
  },

  typography: {
    fontFamily: "defaultRegular, Arial, sans-serif",
    fontFamilyBold: "defaultBold, Arial, sans-serif",
    fontFamilyDemibold: "defaultDemibold, Arial, sans-serif",
    fontSize: `1.5rem`,
    fontWeight: 700,
    fontSizeMobile: `1rem`,
    fontWeightMobile: 900,
    fontFamilyDefaultBold: "defaultBold"
  },

  circleButton: {
    color: "#4c4c4c",
    hoverColor: "#ffffff"
  },

  general: {
    brandsColors: {
      casino: "#72c015",
      poker: "#0370dd",
      sport: "#fc6200"
    }
  }
};
